import { TableColumnsSetting } from '@/interfaces/table-setting';
import { MmssDocumentationModel } from '@/models/tables/mmss-documentation.model';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeliveryCardboardService } from '@services/delivery-cardboard.service';
import { DocumentationMmssService } from '@services/documentation-mmss.service';

export class MmssDocumentationSettings {
  public static getColumnsSetting(
    documentationMmssService: DocumentationMmssService,
  ): TableColumnsSetting<keyof MmssDocumentationModel> {
    return [
      {
        name: 'btnDownload',
        customButton: true,
        index: 0,
        unsortable: true,
      },
      {
        name: 'btnEdit',
        customButton: true,
        index: 1,
        unsortable: true,
      },
      {
        name: 'btnDelete',
        customComponent: true,
        unsortable: true,
      },
      {
        name: 'id',
        text: 'ID',
        type: 'number',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'fonteDocumentoMMSS',
        text: 'Fonte',
        type: 'object',
        propertyToShow: 'descrizione',
        filter: {
          type: 'select',
          options: documentationMmssService.getSourceMmssDocuments().pipe(
            map((brands) =>
              brands.map(({ id, descrizione }) => ({
                [id]: `${descrizione}`,
              })),
            ),
          ),
        },
      },
      {
        name: 'tipologiaDocumentoMMSS',
        text: 'Tipologia',
        type: 'object',
        propertyToShow: 'descrizione',
        filter: {
          type: 'select',
          options: documentationMmssService.getMmssDocumentTypes().pipe(
            map((brands) =>
              brands.map(({ id, descrizione }) => ({
                [id]: `${descrizione}`,
              })),
            ),
          ),
        },
      },
      {
        name: 'maggioreSconto',
        text: 'Maggiore Sconto',
        type: 'object',
        propertyToShow: 'descrizioneMs',
        filter: {
          type: 'select',
          options: documentationMmssService.getBigBuyersByBrand(3).pipe(
            map((bigBuyers) =>
              bigBuyers.map(({ id, codiceMs, descrizioneMs }) => ({
                [id]: `${codiceMs} - ${descrizioneMs}`,
              })),
            ),
          ),
        },
      },
      {
        name: 'descrizione',
        text: 'Descrizione',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'marca',
        text: 'Marca',
        type: 'object',
        propertyToShow: 'descrizioneMarca',
        unsortable: true,
      },
      {
        name: 'anno',
        text: 'Anno',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'trimestre',
        text: 'Trimestre',
        filter: {
          type: 'select',
          options: of([{ I: 'I' }, { II: 'II' }, { III: 'III' }, { IV: 'IV' }]),
        },
      },
      {
        name: 'mese',
        text: 'Mese',
        type: 'mese',
        filter: {
          type: 'select',
          options: of([
            { 1: 'Gennaio' },
            { 2: 'Febbraio' },
            { 3: 'Marzo' },
            { 4: 'Aprile' },
            { 5: 'Maggio' },
            { 6: 'Giugno' },
            { 7: 'Luglio' },
            { 8: 'Agosto' },
            { 9: 'Settembre' },
            { 10: 'Ottobre' },
            { 11: 'Novembre' },
            { 12: 'Dicembre' },
          ]),
        },
      },
      {
        name: 'file',
        text: 'Nome File',
        type: 'object',
        propertyToShow: 'name',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'creator',
        text: 'Creato da',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'created',
        text: 'Data Creazione',
        type: 'datetime',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
